import angular from 'angular';
import SpecialParameter from '../../config/special-parameter.config';

/* @ngInject */
export default function TechnologyService($timeout, BreadcrumbParserService, CacheService, ParameterApiService, SimilarPartsApiService,
                                          SleuthService, DefinitionParameterApiService, SpinnerLoadingService, QueryApiService,
                                          ImageProcessorService) {
    'use strict';

    function updateUniquePartsAndSeriesBySleuth(definitionId, callBackFn) {
        // If sleuth returned any results even if no parts are return
        // Make sure detectedUniqueParts are belong to current technology definition
        if ((SleuthService.getSleuthData().detectedUniqueParts.length > 0 &&
            SleuthService.getSleuthData().detectedUniqueParts[0].leafDefinitionId == definitionId)
            || SleuthService.getSleuthData().message.text.startsWith('We were unable to find any products matching your search.')) {
            callBackFn(SleuthService.getSleuthData().detectedUniqueParts);
        } else { // If no parts but sleuth can return parts
            var queryData = SleuthService.buildQueryParam([definitionId],
                SleuthService.getSleuthData().queryParameterValues);
            SpinnerLoadingService.showLoading('Loading Parts, please wait...');
            QueryApiService.executeParameterValueSearch(queryData, function (response) {
                SleuthService.sendMessage(response, '/browsing/technology');
                if (SleuthService.getSleuthData() != undefined) {
                    SleuthService.handleImageByUniqueParts(response.detectedUniqueParts, CacheService.getDefinition());
                }
                SleuthService.storeSleuthData(response);
                callBackFn(response.detectedUniqueParts);
                SpinnerLoadingService.hideLoading();
            });
        }
    }

    function selectSeries(series, uniqueParts, parameterValue) {
        series.query = parameterValue;
        series.query.selectedFormattedValue = parameterValue.value;
        series.showAllList = false;
        series.showFilteredList = false;
        series.showDownload = true;
        parameterValue.clicked = true;
        // series.clicked = true;

        // Set the first uniquePart that have the same series ID to be the download link
        var keepGoing = true;
        angular.forEach(uniqueParts, function (uniquePart) {
            if (keepGoing) {
                if (uniquePart.series.id == series.query.id) {
                    series.detectedUniquePart = uniquePart;
                    keepGoing = false;
                }
            }
        });

        return series;
    }

    function getSeries(definitionId, callBack, callBackError) {
        DefinitionParameterApiService.getSeries(definitionId, function (series) {
            if (hasValidAvailableSeries()) {
                series.parameterValues = SleuthService.getSleuthData().availableSeries;
            }
            callBack(series);
        }, function (error) {
            callBackError(error);
        });
    }

    function hasValidAvailableSeries() {
        if (SleuthService.getSleuthData() !== undefined && SleuthService.getSleuthData().availableSeries !== undefined &&
            SleuthService.getSleuthData().availableSeries !== null && SleuthService.getSleuthData().availableSeries.length > 0) {
            // Get user's input series
            var inputParameterValueSeries = undefined;
            if (SleuthService.getSleuthData().queryParameterValues != null) {
                for (var i = 0; i < SleuthService.getSleuthData().queryParameterValues.length; ++i) {
                    if (SleuthService.getSleuthData().queryParameterValues[i].parameterId == 3) {
                        // inputParameterValueSeries = SleuthService.getSleuthData().queryParameterValues[i];
                        // Show all series if user selected series.
                        return false;
                    }
                }

                if (inputParameterValueSeries !== undefined) {
                    for (var i = 0; i < SleuthService.getSleuthData().availableSeries.length; ++i) {
                        if (SleuthService.getSleuthData().availableSeries[i].id == inputParameterValueSeries.id) {
                            return true;
                        }
                    }
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
        return false;
    }

    function getNewParameterValues(uniqueParts, definitionId, callBack, callBackError) {
        if (hasValidAvailableSeries()) {
            callBack(SleuthService.getSleuthData().availableSeries, uniqueParts);
        } else {
            DefinitionParameterApiService.getSeries(definitionId, function (newSeries) {
                callBack(newSeries.parameterValues, uniqueParts);
            }, function (error) {
                callBackError(error);
            });
        }
    }

    function findSeriesValueBySleuthData() {
        var seriesValues = [];
        if (SleuthService.getSleuthData() !== undefined && SleuthService.getSleuthData().queryParameterValues !== undefined) {
            for (var i = 0; i < SleuthService.getSleuthData().queryParameterValues.length; ++i) {
                if (SleuthService.getSleuthData().queryParameterValues[i].parameterName === 'Series') {
                    seriesValues.push(SleuthService.getSleuthData().queryParameterValues[i].value);
                }
            }
        }
        return seriesValues;
    }

    function splitParameterValuesForDisplay(uniquePart) {
        var i;
        var j;
        var chunk = 3;
        var max = uniquePart.parameterValues.length;

        uniquePart.splittedParameterValues = [];

        if (max > 9) {
            max = 9;
        }

        for (i = 0, j = max; i < j; i += chunk) {
            uniquePart.splittedParameterValues.push(uniquePart.parameterValues.slice(i, i + chunk));
        }

        // Now suppress the STEP File parameter value
        for (i = 0; i < uniquePart.splittedParameterValues.length; i++) {
            for (var h = 0; h < uniquePart.splittedParameterValues[i].length; h++) {
                if (uniquePart.splittedParameterValues[i][h].parameterName === 'STEP') {
                    uniquePart.splittedParameterValues[i].splice(h, 1);
                }
            }
        }

        // Now suppress the Datasheet parameter value
        for (i = 0; i < uniquePart.splittedParameterValues.length; i++) {
            for (var h = 0; h < uniquePart.splittedParameterValues[i].length; h++) {
                if (uniquePart.splittedParameterValues[i][h].parameterName === 'Datasheet') {
                    uniquePart.splittedParameterValues[i].splice(h, 1);
                }
            }
        }

        // Now suppress the KSIM parameter value
        for (i = 0; i < uniquePart.splittedParameterValues.length; i++) {
            for (var h = 0; h < uniquePart.splittedParameterValues[i].length; h++) {
                if (uniquePart.splittedParameterValues[ i ][ h ].parameterName === SpecialParameter.KSIM) {
                    uniquePart.splittedParameterValues[i].splice(h, 1);
                }
            }
        }
    }

    function getParents(similartPartParents) {
        var parents = [];
        var origDefinitions = CacheService.getAllDefinitions();
        for (var i = 0; i < similartPartParents.length; ++i) {
            for (var j = 0; j < origDefinitions.length; ++j) {
                if (origDefinitions[j].id == similartPartParents[i]) {
                    parents.push(origDefinitions[j]);
                    origDefinitions = origDefinitions[j].childDefinitions;
                    break;
                }
            }
        }
        return parents;
    }

    function cacheDefinitionBySimilarPart(similarPart, callbackFn) {
        // Now change the current page's definition to the argument passed in.
        var parents = [];
        var origDefinitions = CacheService.getAllDefinitions();
        for (var i = 0; i < similarPart.parents.length; ++i) {
            for (var j = 0; j < origDefinitions.length; ++j) {
                if (origDefinitions[j].id == similarPart.parents[i]) {
                    parents.push(origDefinitions[j]);
                    origDefinitions = origDefinitions[j].childDefinitions;
                    break;
                }
            }
        }
        CacheService.storeDefinition(similarPart.definition);
        CacheService.restoreParentDefinition(getParents(similarPart.parents));
        callbackFn();
    }

    function hideSeriesWithoutParts(series, parts) {
        var isUniquePnFound,
            seriesWithPn = [];
        for (var i = 0; i < series.parameterValues.length; ++i) {
            isUniquePnFound = false;
            for (var j = 0; j < parts.length; ++j) {
                if (parts[j].uniquePn.startsWith(series.parameterValues[i].value)) {
                    isUniquePnFound = true;
                    seriesWithPn.push(series.parameterValues[i]);
                    break;
                }
            }
            if (!isUniquePnFound) {
                series.parameterValues.splice(i, 1);
                --i;
            }
        }
        return seriesWithPn;
    }

    // This function works like MAP. Store data by parameterId
    function addValue(values, value) {
        var found = false;
        for (var j = 0; j < values.length; ++j) {
            if (values[j].id == value.parameterId) {
                values[j].values.push(value);
                found = true;
            }
        }
        if (!found) {
            values.push({
                id: value.parameterId,
                values: [value]
            });
        }
    }

    function getSimilarPartsInputValueArray(parameterIds) {
        var results = [];
        var limitedParmValues = [];
        angular.forEach(SleuthService.getSleuthData().queryParameterValues, function (value) {
            for (var i = 0; i < parameterIds.length; ++i) {
                if (parameterIds[i] == value.parameterId) {
                    addValue(limitedParmValues, value);
                    break;
                }
            }
        });

        for (var i = 0; i < limitedParmValues.length; ++i) {
            results.push(limitedParmValues[i].values[0].id);
        }
        return results;
    }

    function getLimitingParameters(callBack) {
        var parmValues = [];
        if (SleuthService.getSleuthData() !== undefined) {
            ParameterApiService.getParametersByDefinitionAndLimiting(CacheService.getDefinition().id, function (parameters) {
                var parameterIds = [];

                parameters.forEach(function (parameter) {
                    parameterIds.push(parameter.id);
                });

                parmValues = getSimilarPartsInputValueArray(parameterIds);
                callBack(parmValues);
            });
        } else {
            callBack(parmValues);
        }
    }

    function buildSimilarPartsInput(callBack) {
        getLimitingParameters(function (values) {
            var similarPartsInput = {
                definitionId: CacheService.getDefinition().id,
                valueArray: values
            };
            callBack(similarPartsInput);
        });
    }

    return {
        selectSeries: selectSeries,
        getSeries: getSeries,
        getNewParameterValues: getNewParameterValues,
        getSeriesValueUsingSleuthData: findSeriesValueBySleuthData,
        splitParameterValuesForDisplay: splitParameterValuesForDisplay,
        cacheDefinitionBySimilarPart: cacheDefinitionBySimilarPart,
        filterOutPartsWithNoSeries: hideSeriesWithoutParts,
        updateUniquePartsAndSeriesBySleuth: updateUniquePartsAndSeriesBySleuth,
        getLimitingParameters: getLimitingParameters,
        getSimilarParts: function (callBack) {
            buildSimilarPartsInput(function (similarPartsInput) {
                SimilarPartsApiService.similarPartsCompare(similarPartsInput, function (similarProducts) {
                    const similarProductDefinitions = [];
                    angular.forEach(similarProducts, function (similarProduct) {
                        similarProductDefinitions.push(similarProduct.definition);
                    });
                    ImageProcessorService.processImagesAndDefinitions(null, similarProductDefinitions);
                    for (var i = 0; i < similarProductDefinitions.length; i++) {
                        similarProductDefinitions[i].definitionContext = BreadcrumbParserService.parseBreadcrumbToSentence(similarProductDefinitions[i]);
                    }
                    callBack(similarProducts);
                });
            });
        }

    };
}
